<template>
  <div
    class="ncrm-contract-details__side-row ncrm-contract-details__side-row--editable ncrm-contract-side-editable-row"
    :class="{ 'ncrm-contract-side-editable-row--editing': editing }"
    role="button"
    :tabindex="editing ? -1 : 0"
    @click="emitStart"
    @keydown.enter="emitStartFromKeyboard"
    @keydown.space="emitStartFromKeyboard"
  >
    <div class="ncrm-contract-side-editable-row__label">
      <v-icon size="14" class="ncrm-contract-side-editable-row__icon">{{ icon }}</v-icon>
      {{ label }}
      <v-icon size="11" class="ncrm-contract-side-editable-row__edit-icon">mdi-pencil-outline</v-icon>
    </div>
    <slot v-if="editing" name="editor" />
    <div v-else class="ncrm-contract-side-editable-row__value" :class="valueClass">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "NcrmContractSideEditableRow",
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    valueClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
  emits: ["start"],
  methods: {
    emitStart() {
      if (this.editing) return;
      this.$emit("start");
    },
    emitStartFromKeyboard(event) {
      if (this.editing) return;
      event.preventDefault();
      this.$emit("start");
    },
  },
};
</script>

<style scoped>
.ncrm-contract-side-editable-row {
  display: grid;
  gap: 2px;
  padding: 5px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.ncrm-contract-side-editable-row:hover,
.ncrm-contract-side-editable-row:focus-visible {
  background: var(--ncrm-color-hover-soft);
  outline: none;
}

.ncrm-contract-side-editable-row + .ncrm-contract-side-editable-row {
  border-top: 1px solid var(--ncrm-color-border-subtle);
}

.ncrm-contract-side-editable-row__label {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(var(--v-theme-on-surface), 0.62);
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 1.18;
}

.ncrm-contract-side-editable-row__icon {
  opacity: 0.72;
  flex-shrink: 0;
}

.ncrm-contract-side-editable-row__edit-icon {
  color: rgba(var(--v-theme-on-surface), 0.46);
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.ncrm-contract-side-editable-row:hover .ncrm-contract-side-editable-row__edit-icon,
.ncrm-contract-side-editable-row:focus-visible .ncrm-contract-side-editable-row__edit-icon {
  opacity: 0.6;
}

.ncrm-contract-side-editable-row__value {
  color: var(--ncrm-color-text-strong);
  font-size: 1.02rem;
  font-weight: 500;
  line-height: 1.22;
  word-break: break-word;
}
</style>
